import '../../styles/bitacora.style.css'
import {useDispatch, useSelector} from 'react-redux'
import { State } from '../../../../reducers'
import { postAnularLibroVentas, postGenerarLibroVentas } from '../../../../actions/libros/libros-ventas.actions'
import { ItemLibroGenerado } from '../../../../interfaces/libros.interface'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { Pagination } from '../../../../components/Pagination'
import { useState } from 'react'

import AnularIcon from '../../../../media/felsv/DarkAnular.svg'
import DownloadIcon from '../../../../media/felsv/Download.svg';
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'

const TableLibros = () => {
  const {dataConsultaLibros, formConsultaLibros} = useSelector((state: State) => state.libros);

  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [modalConfirmLibro, setModalConfirmLibro] = useState<boolean>(false);
  const [selectedLibro, setSelectedLibro] = useState<ItemLibroGenerado|null>(null); 

  const dispatch = useDispatch();
  
  const handleGenerarLibro = (item: ItemLibroGenerado) => {
    dispatch(postGenerarLibroVentas(item.idlibroventa, {...formConsultaLibros, tipoLibro: item.tipolibro}))
  }

  const handleOpenAnular = (item: ItemLibroGenerado) => {
    setSelectedLibro(item);
    setModalConfirmLibro(true);
  }

  const handleAnularLibro = async () => {
    if (selectedLibro) {
      if (await dispatch(postAnularLibroVentas(selectedLibro))) {
        setModalConfirmLibro(false);
      }
    }
  }

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      {
        modalConfirmLibro 
        && <ModalConfirm 
            title={"Confirmación"} 
            detail={`Se procede a anular el libro de IVA seleccionado. (${selectedLibro?.fechainicio} - ${selectedLibro?.fechafin}) ¿Está seguro de que quiere realizar esta acción?`} 
            actionConfirm={handleAnularLibro} 
            closeModalConfirm={() => setModalConfirmLibro(false)} 
          />
      }
      <BasicCardDocumentos 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Documentos" 
        size="l"
      >
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
              <thead>
                <tr>
                  <td>Fecha Inicial</td>
                  <td>Fecha Final</td>
                  <td>Tipo de libro</td>
                  <td>Estatus</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {
                  dataConsultaLibros?.length > 0 && 
                  (
                    currentItems.map((item: ItemLibroGenerado, index: number) => (
                      <tr key={(index+item.fechacreacion)}>
                        <td data-label="Fecha Inicial">{item.fechainicio}</td>
                        <td data-label="Fecha Final">{item.fechafin}</td>
                        <td data-label="Tipo de libro">{item.desctipolibro}</td>
                        <td data-label="Estatus">
                          <div className={`badge-estado ${item.anulado === "False" ? 'badge-estado-activo' : 'badge-estado-anulado'}`} style={{ maxWidth: '120px'}}>
                            {
                              item.anulado === "False" ? "Vigente" : "Anulado"
                            }
                          </div>
                        </td>
                        <td data-label='Acciones' className='table-td'>
                          
                          {
                            item.anulado === "False"
                            ?
                              <>
                                <Tooltip content='Descargar Libro'>
                                  <button className='table-action' onClick={(e) => handleGenerarLibro(item)}>
                                    <img src={DownloadIcon} alt='Download' className='table-img-action' />
                                  </button>
                                </Tooltip>
                                <Tooltip content='Anular Libro'>
                                  <button className='table-action' onClick={(e) => handleOpenAnular(item)}>
                                    <img src={AnularIcon} alt='Anular' className='table-img-action' />
                                  </button>
                                </Tooltip>
                              </>
                            :
                              <div>N/A</div>
                          }
                        </td>
                      </tr>
                    ))
                  )
                }  
              </tbody>
            </table>
            {dataConsultaLibros?.length > 0 && (
              <Pagination
                data={dataConsultaLibros}
                state={(items: Array<any>) => setCurrentItems(items)}
                items={20}
              />
            )}
          </div>
        </div>
      </BasicCardDocumentos>
    </div>
  )
}

export default TableLibros
